import React, { useContext, useRef, useState } from "react";
import { createBrowserRouter, createMemoryRouter, generatePath, matchPath, Navigate, redirect } from "react-router-dom";
import { systemCode, urls } from "../../..";
import { concatUrlPathnames, removeMultipleSlashes } from "../../../data/sport-utils";
import { appConfig } from "../../../appConfig";
import Prematch from "../../../prematch/Prematch";
import { getConfiguration } from '../../../data/utils/configuration';
import { fetchOriginalPath, handleCanonicalUrl } from "../../../data/seo/seoUtils";
import { XSeoContext } from "../XSeoConf";
import LiveDataProviderChildren from "../../../live/LiveDataProviderChildren";
import Landing from "../../../landing/Landing";
import { getEnv } from "../../../data/env";
import LandingNewWh from "../../../landing/LandingNewWh";
import { XRouterContext } from "./XRouterContext";
import { getPathnameRouteInfo } from "./seoUtils";
import { getLegacyRoutes } from "./legacy-routes";

var ctxs;

function isBetwayFrontend() {
    const frontendVersion = getEnv('REACT_APP_FRONTEND_VERSION');
    return 'betway' === frontendVersion;
}

function handleOpenFromPath(pathname) {
    if(pathname?.endsWith('/')) {
        pathname = pathname.substring(0,pathname.length-1);
    }
    const open = {};
    const last = pathname.substring((pathname.lastIndexOf('/')));
    //const regex = /([^\/]+_-?\d+) {1,5}/mg;
    //const regex = /([^\/,]+(_-?\d+) {1,5})/mg;
    const regex = /([^/,]+(_-?\d+){1,5}(_m-?\d+)?)/mg;
    const suffix = last && last.match(regex);
    let parts = (suffix?.length === 1 && suffix?.[0]?.split("_")) || [];

    if(parts?.length > 0 && (isNaN(parts[0]) || parts.length > 5 )) {
        parts.splice(0, 1);
    }

    if(parts?.[0] === 'live') {
        open.isLive = true;
        parts = parts.slice(1);
    }
   
    switch (parts.length) {
        case 1: 
            open.sport = {
                sportId: parts[0]
            }
            break;
        case 2: 
            open.country = {
                 sportId: parts[0],
                countryId: parts[1]
            }
            break;
        case 3: 
            open.tournament = {
                sportId: parts[0],
                countryId: parts[1],
                tournamentId: parts[2]
            }
            break;
        case 5: 
            open.tournament = {
                sportId: parts[0],
                countryId: parts[1],
                tournamentId: parts[2]
            }
            open.match = {
                pal: parts[3],
                avv: parts[4]
            }
            break;
        case 6: 
            open.tournament = {
                sportId: parts[0],
                countryId: parts[1],
                tournamentId: parts[2]
            }
            open.match = {
                pal: parts[3],
                avv: parts[4]
            }
            open.macro = {
                macroId : parts[5].substring(parts[5].indexOf('m')+1)
            }
            break;
        default:
            return null;
    }
    return open;
}

export function handleUrlRewrite(pathname) {
    const conf = getConfiguration();
    pathname = appConfig?.URL_PATH_MAPPINGS?.[pathname] || pathname
    if(conf.seo) {
        const [routeFromPath,cleanedUpPathname,isEnvBasename] = getPathnameRouteInfo(pathname);
        pathname = cleanedUpPathname;
        if(!routeFromPath) {
            const originalPath = fetchOriginalPath(cleanedUpPathname,true);
            if(originalPath) {
                pathname = originalPath;
            }
            if(!isEnvBasename && !pathname.startsWith(concatUrlPathnames(urls.basename,urls.live.base))) {
                if(urls.prematch.base !== '/' || originalPath) {
                    pathname = pathname?.replace(urls.prematch.base,concatUrlPathnames(urls.basename,urls.prematch.base));
                }
            }
        }else{
            handleCanonicalUrl(pathname);
        }
        ctxs?.xseoContext?.setSeoRealPathname(pathname);
        if(isEnvBasename) {
            pathname = concatUrlPathnames(appConfig.BASENAME,pathname);
        }
    }
    let path = removeMultipleSlashes(pathname);

    const basePrematch =  matchPath({
        path: removeMultipleSlashes(`${urls.basename}/${urls.prematch.base}`),
        end: false,
        caseSensitive: false
    },path);

    const baseLive =  matchPath({
        path: removeMultipleSlashes(`${urls.basename}/${urls.live.base}`),
        end: false,
        caseSensitive: false
    },path);

    const prematchDatePath = matchPath({
        path: removeMultipleSlashes(`${urls.basename}/${urls.prematch.base}/${urls.prematch.date}`),
        end: false,
        caseSensitive: false
    },path);

    if(isBetwayFrontend && prematchDatePath?.pathname) {
        path = removeMultipleSlashes(path);
        //console.debug(pathname+" REWRITED TO "+path)
        return path;
    }

    const open = handleOpenFromPath(pathname);
    const basePath = open?.isLive?`${urls.basename}/${urls.live.base}` : basePrematch?.pathname || baseLive?.pathname;
    
    if(open?.sport) {
        path = generatePath(`${basePath}/:id`, { id: open.sport.sportId });
    }else if(open?.country) {
        path = generatePath(`${basePath}/${urls.prematch.category}/:sportId/:categoryId`, 
                            { sportId: open.country.sportId, categoryId: open.country.countryId }
                            );
    }else if(open?.tournament && !open?.match) {
        path = generatePath(`${basePath}/${urls.prematch.tournament}/:id`, 
                             { id: [open.tournament.sportId, open.tournament.countryId,open.tournament.tournamentId].join('_') }
                            );
    }else if(open?.tournament && open?.match && !open?.macro) {
        const tournamentId = [open.tournament.sportId, open.tournament.countryId,open.tournament.tournamentId].join('_');
        const matchId = [open.match.pal, open.match.avv].join('_');
        path = generatePath(`${basePath}/${urls.prematch.tournament}/:tournamentId/${urls.prematch.event}/:matchId`, 
                             { matchId: matchId, tournamentId: tournamentId }
                            );
    }else if(open?.tournament && open?.match && open?.macro) {
        const tournamentId = [open.tournament.sportId, open.tournament.countryId,open.tournament.tournamentId].join('_');
        const matchId = [open.match.pal, open.match.avv].join('_');
        const macroId = open.macro.macroId
        path = generatePath(`${basePath}/${urls.prematch.tournament}/:tournamentId/${urls.prematch.event}/:matchId/:macroId`, 
                             { matchId: matchId, tournamentId: tournamentId, macroId:macroId }
                            );
    }
    //console.log(path)
    path = removeMultipleSlashes(path);
    console.debug(pathname+" REWRITED TO "+path)
    return path;
}

function XRouterConf(props) {
     ctxs = useRef({}).current;
     ctxs.xseoContext = useContext(XSeoContext);
     const legacyRoutes = getLegacyRoutes();
     const [xrouterContext] = useState({
        legacy: legacyRoutes,
        router: null,
        urls:window.xs_routes[systemCode] || window.xs_routes['DEFAULT'],
        lastNavigationType: null,
        isMemoryRouter: function() {
            return this.legacy;
        },
        isBrowserRouter: function() {
            return !this.legacy;
        },
        getRouter: function(routeElements) {
            if(!this.router) {
                if(this.isMemoryRouter()) {
                    this.router = createMemoryRouter(routeElements)
                     
                 }else{
                     this.router =  createBrowserRouter(routeElements);
                 }
            }
            return this.router;
        },
        
        navigateTo: function(to) {
            return <Navigate replace={this.isMemoryRouter()} to={to} />
        },
        redirectTo: function(url,state,isRelative) {
            if(this.legacy) {
                if(isRelative) {
                    url = concatUrlPathnames(window.location.pathname,url);
                }
                window.history.pushState(window.history.state, null, url)
                return redirect(concatUrlPathnames(urls.basename,handleUrlRewrite(url)),{'replace':true,state:state});
            }else{
                return redirect(url);
            }
        },
        getPrematchComponent: function() {
            const conf = getConfiguration();
            if (conf.pls === 'LANDING_WIDGETS') {
                return (
                    <LiveDataProviderChildren>
                        <Landing />
                    </LiveDataProviderChildren>
                )
            } 
            else if (conf.pls === 'LANDING_4') {
                return (
                        <LandingNewWh />
                )}
            else {
                if(urls.prematch.home) {
                    return this.navigateTo([urls.base,urls.prematch.base,urls.prematch.home].join('/'))
                }else{
                    return <Prematch />
                }
            }
        }
    });


    return (
        <XRouterContext.Provider value={xrouterContext}>
            {props.children}
        </XRouterContext.Provider>
    );

}

export default XRouterConf;